import Banner from './General/Banner'
import OtherBanner from './General/OtherBanner'
import BannerCard from './General/BannerCard'

import Popup from './General/Popup'
import PopupCard from './General/PopupCard'

import User from './System/User'
import UserSite from './System/UserSite'

import PartnerInsuranceCompany from './Rte/PartnerInsuranceCompany'
import PartnerInsuranceCompanyCard from './Rte/PartnerInsuranceCompanyCard'
import GroupCompany from './Rte/GroupCompany'
import GroupCompanyCard from './Rte/GroupCompanyCard'
import Customer from './Rte/Customer'
import SortitionParticipants from './Rte/SortitionParticipants'
import { BudgetsExport } from './Rte/BudgetExport'
import Subject from './Rte/Subject'
import SubjectCard from './Rte/SubjectCard'
import Campaign from './Rte/Campaign'
import Product from './Rte/Product'
import ProductCard from './Rte/ProductCard'

export default {
  General: {
    Banner,
    OtherBanner,
    BannerCard,
    Popup,
    PopupCard
  },
  System: {
    User,
    UserSite
  },
  Rte: {
    PartnerInsuranceCompany,
    PartnerInsuranceCompanyCard,
    GroupCompany,
    GroupCompanyCard,
    Customer,
    SortitionParticipants,
    BudgetsExport,
    Subject,
    SubjectCard,
    Campaign,
    Product,
    ProductCard
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/index.js